import { action, Action, thunk, Thunk } from "easy-peasy";
import cryptoJS from "crypto-js";
import {
    loginApi,
    forgotPasswordApi,
    getDiplomasApi,
    getStatesApi,
    getTimeZoneApi,
    signUpApi,
    patientSignUpApi,
    GetDashboardCounts,
    GetTherapistProfile,
    GetMyPatients,
    GetMyAppoinments,
    GetAssesmentPdf,
    SavePatientRefuseAssessment,
    UpdateAppoinmentStatus,
    GetTherapistTimeSlots,
    AdminSendEmail,
    SaveNotification,
    UploadDocument,
    GetPatientAssessments,
    GetPatientNotes,
    SavePetientNote,
    GetVideos,
    SaveShareVideos,
    PatientSendEmail,
    SaveAssessmentNotes,
    PatientGetProfile,
    getPatientMedicalHistory,
    getTherapistGetSchedule,
    getTherapistAppoinment,
    getTherapistGetTimeInterval,
    getTherapistGetPopupdata,
    therapistSaveScheduleTime,
    therapistSaveAppoinment,
    patientSaveAppoinment,
    patientCancelRefuseAssessment,
    therapistRevertVPTCancelAssessment,
    GetPatientPrescriptionData,
    patientDischargeManage,
    SaveTherapistProfile,
    UploadPhoto,
    adminUploadPhoto,
    therapistSaveScheduleOnUncheck,
    getPatientHealthDetails,
    GetPatientOtherAssessment,
    GetPreviousAssessment,
    SavePatientOtherAssessment,
    GetAssessmentTemplates,
    SaveAssessmentTemplate,
    getPatientAssessment,
    getPatientRefuseAssessment,
    getPatientCervicalAssessment2,
    getPatientCervicalAssessment3,
    getPatientLowerAssessment3,
    getMedicalHistories,
    patientMedicalHistory,
    getPatientLumbarAssessment2,
    getPatientLumbarAssessment3,
    adminManageFile,
    adminManagePatientNew,
    adminGetAppoinmentsStatus,
    adminGetQualityAnalysisReport,
    adminGetDmeSurgicalAppoinments,
    adminGetUserDetails,
    adminGetAllTherapists,
    adminGetCompanies,
    adminSearchPatient,
    adminSaveInboxMessage,
    getPatientLowerAssessment2,
    getPatientThoracicAssessment2,
    getPatientThoracicAssessment3,
    getPatientUpperAssessment2,
    getPatientUpperAssessment3,
    getPatientVestibularAssessment2,
    getPatientVestibularAssessment3,
    getPatientReAssessment,
    getPatientReAssessment2,
    getPatientGetAppoinments,
    getSharedVideos,
    savePatientMedicalHistory,
    patientAssessmentZoomDetailWeb,
    getPatientTherapists,
    getCompanies,
    getCompaniesforPatient,
    patientSaveAppoinmentNew,
    patientRequestForAppoinment,
    adminRegisterNurse,
    getAdminGetDashBoardData,
    adminEnableDisableUser,
    adminOverrideUserNPI,
    getAdminGetMyPatient,
    getAdminGetMyPayments,
    getAdminGetMarketingData,
    getAdminGetAppointments,
    adminAppRejUser,
    getAdminGetAppointmentPays,
    adminUpdateAppointmentPay,
    getAdminGetAccountReceived,
    getAdminGetDischargeReport,
    getAdminGetFirstAppoinments,
    getAdminGetRequestsForAppointment,
    getAdminGetPatientDischarge,
    getAdminDownloadPatientDischarge,
    getAdminDownloadPatientRefusal,
    getAdminGetPatientRefusal,
    adminGetUpdateUserFees,
    adminUpdateRequestStatus,
    getAdminGetAccountReceivable,
    adminGenerateInvoice,
    adminGetTherapistAppoinments,
    adminGetAllTherapist,
    adminUpdateAccountReceivable,
    adminGetSelfPayAppointments,
    stripeCheckoutCreateIntent,
    stripeCheckoutBookSelfPayAppointment,
    adminUpdateTherapistFees,
    setPasswordApi,
    updateRstPasswordink,
    adminSubmitClaimForm,
    adminGetCAPrisonReport,
    adminGetPrisonSites,
    adminGetPrisonDiagnosisCodes
} from "../../api/apicall";

export interface AppModel {
    loader: boolean;
    loaderText: string;
    loginData?: any;
    crumbs?: any;
    setCrumbs: Action<AppModel, any>;
    setLoader: Action<AppModel, any>;
    hideLoader: Action<AppModel, boolean>;
    showLoader: Thunk<AppModel, boolean>;
    closeLoader: Thunk<AppModel, boolean>;
    setLoginData: Action<AppModel, any>;
    loginUserApi: Thunk<AppModel, any>;
    forgotPasswordApi: Thunk<AppModel, any>;
    getDiplomasApi: Thunk<AppModel, any>;
    getStatesApi: Thunk<AppModel, any>;
    getTimeZoneApi: Thunk<AppModel, any>;
    signUpApi: Thunk<AppModel, any>;
    patientSignUpApi: Thunk<AppModel, any>;
    GetDashboardCounts: Thunk<AppModel, any>;
    GetTherapistProfile: Thunk<AppModel, any>;
    GetMyPatients: Thunk<AppModel, any>;
    GetMyAppoinments: Thunk<AppModel, any>;
    GetAssesmentPdf: Thunk<AppModel, any>;
    SavePatientRefuseAssessment: Thunk<AppModel, any>;
    UpdateAppoinmentStatus: Thunk<AppModel, any>;
    GetTherapistTimeSlots: Thunk<AppModel, any>;
    AdminSendEmail: Thunk<AppModel, any>;
    SaveNotification: Thunk<AppModel, any>;
    UploadDocument: Thunk<AppModel, any>;
    GetPatientAssessments: Thunk<AppModel, any>;
    GetPatientNotes: Thunk<AppModel, any>;
    SavePetientNote: Thunk<AppModel, any>;
    GetVideos: Thunk<AppModel, any>;
    SaveShareVideos: Thunk<AppModel, any>;
    PatientSendEmail: Thunk<AppModel, any>;
    SaveAssessmentNotes: Thunk<AppModel, any>;
    PatientGetProfile: Thunk<AppModel, any>;
    getPatientMedicalHistory: Thunk<AppModel, any>;
    getTherapistGetSchedule: Thunk<AppModel, any>;
    getTherapistAppoinment: Thunk<AppModel, any>;
    getTherapistGetTimeInterval: Thunk<AppModel, any>;
    getTherapistGetPopupdata: Thunk<AppModel, any>;
    therapistSaveScheduleTime: Thunk<AppModel, any>;
    therapistSaveAppoinment: Thunk<AppModel, any>;
    patientSaveAppoinment: Thunk<AppModel, any>;
    patientCancelRefuseAssessment: Thunk<AppModel, any>;
    therapistRevertVPTCancelAssessment: Thunk<AppModel, any>;
    GetPatientPrescriptionData: Thunk<AppModel, any>;
    patientDischargeManage: Thunk<AppModel, any>;
    SaveTherapistProfile: Thunk<AppModel, any>;
    UploadPhoto: Thunk<AppModel, any>;
    adminUploadPhoto: Thunk<AppModel, any>;
    therapistSaveScheduleOnUncheck: Thunk<AppModel, any>;
    getPatientHealthDetails: Thunk<AppModel, any>;
    GetPatientOtherAssessment: Thunk<AppModel, any>;
    GetPreviousAssessment: Thunk<AppModel, any>;
    SavePatientOtherAssessment: Thunk<AppModel, any>;
    GetAssessmentTemplates: Thunk<AppModel, any>;
    SaveAssessmentTemplate: Thunk<AppModel, any>;
    getPatientAssessment: Thunk<AppModel, any>;
    getPatientRefuseAssessment: Thunk<AppModel, any>;
    getPatientCervicalAssessment2: Thunk<AppModel, any>;
    getPatientCervicalAssessment3: Thunk<AppModel, any>;
    getPatientLowerAssessment3: Thunk<AppModel, any>;
    getMedicalHistories: Thunk<AppModel, any>;
    patientMedicalHistory: Thunk<AppModel, any>;
    getPatientLumbarAssessment2: Thunk<AppModel, any>;
    getPatientLumbarAssessment3: Thunk<AppModel, any>;
    adminManageFile: Thunk<AppModel, any>;
    adminManagePatientNew: Thunk<AppModel, any>;
    adminGetAppoinmentsStatus: Thunk<AppModel, any>;
    adminGetQualityAnalysisReport: Thunk<AppModel, any>;
    adminGetCAPrisonReport: Thunk<AppModel, any>;
    adminGetDmeSurgicalAppoinments: Thunk<AppModel, any>;
    adminGetUserDetails: Thunk<AppModel, any>;
    adminGetAllTherapists: Thunk<AppModel, any>;
    adminGetCompanies: Thunk<AppModel, any>;
    adminGetPrisonSites: Thunk<AppModel, any>;
    adminGetPrisonDiagnosisCodes: Thunk<AppModel, any>;
    adminSearchPatient: Thunk<AppModel, any>;
    adminSaveInboxMessage: Thunk<AppModel, any>;
    getPatientLowerAssessment2: Thunk<AppModel, any>;
    getPatientThoracicAssessment2: Thunk<AppModel, any>;
    getPatientThoracicAssessment3: Thunk<AppModel, any>;
    getPatientUpperAssessment2: Thunk<AppModel, any>;
    getPatientUpperAssessment3: Thunk<AppModel, any>;
    getPatientVestibularAssessment2: Thunk<AppModel, any>;
    getPatientVestibularAssessment3: Thunk<AppModel, any>;
    getPatientReAssessment: Thunk<AppModel, any>;
    getPatientReAssessment2: Thunk<AppModel, any>;
    getPatientGetAppoinments: Thunk<AppModel, any>;
    getSharedVideos: Thunk<AppModel, any>;
    savePatientMedicalHistory: Thunk<AppModel, any>;
    patientAssessmentZoomDetailWeb: Thunk<AppModel, any>;
    getPatientTherapists: Thunk<AppModel, any>;
    getCompanies: Thunk<AppModel, any>;
    getCompaniesforPatient: Thunk<AppModel, any>;
    patientSaveAppoinmentNew: Thunk<AppModel, any>;
    patientRequestForAppoinment: Thunk<AppModel, any>;
    adminRegisterNurse: Thunk<AppModel, any>;
    getAdminGetDashBoardData: Thunk<AppModel, any>;
    adminEnableDisableUser: Thunk<AppModel, any>;
    adminOverrideUserNPI: Thunk<AppModel, any>;
    getAdminGetMyPatient: Thunk<AppModel, any>;
    getAdminGetMyPayments: Thunk<AppModel, any>;
    getAdminGetMarketingData: Thunk<AppModel, any>;
    adminAppRejUser: Thunk<AppModel, any>;
    getAdminGetAppointments: Thunk<AppModel, any>;
    getAdminGetAppointmentPays: Thunk<AppModel, any>;
    adminUpdateAppointmentPay: Thunk<AppModel, any>;
    getAdminGetAccountReceived: Thunk<AppModel, any>;
    getAdminGetDischargeReport: Thunk<AppModel, any>;
    getAdminGetFirstAppoinments: Thunk<AppModel, any>;
    getAdminGetRequestsForAppointment: Thunk<AppModel, any>;
    getAdminGetPatientDischarge: Thunk<AppModel, any>;
    getAdminDownloadPatientDischarge: Thunk<AppModel, any>;
    getAdminDownloadPatientRefusal: Thunk<AppModel, any>;
    getAdminGetPatientRefusal: Thunk<AppModel, any>;
    adminGetUpdateUserFees: Thunk<AppModel, any>;
    getAdminGetAccountReceivable: Thunk<AppModel, any>;
    adminGenerateInvoice: Thunk<AppModel, any>;
    adminUpdateRequestStatus: Thunk<AppModel, any>;
    adminGetTherapistAppoinments: Thunk<AppModel, any>;
    adminGetAllTherapist: Thunk<AppModel, any>;
    adminUpdateAccountReceivable: Thunk<AppModel, any>;
    adminGetSelfPayAppointments: Thunk<AppModel, any>;
    stripeCheckoutCreateIntent: Thunk<AppModel, any>;
    stripeCheckoutBookSelfPayAppointment: Thunk<AppModel, any>;
    adminUpdateTherapistFees: Thunk<AppModel, any>;
    setPasswordApi: Thunk<AppModel, any>;
    updateRstPasswordink: Thunk<AppModel, any>; 
    adminSubmitClaimForm: Thunk<AppModel, any>;
}

const appModel: AppModel = {
    loader: false,
    loaderText: "",
    setLoader: action((state, payload) => {
        state.loader = payload;
        state.loaderText = payload?.lodingText;
    }),
    setCrumbs: action((state, payload) => {
        state.crumbs = payload;
    }),
    showLoader: thunk((actions, payload) => {
        actions.setLoader(payload || true);
    }),
    hideLoader: action((state, payload) => {
        state.loader = payload;
    }),
    closeLoader: thunk((actions) => {
        actions.hideLoader(false);
    }),
    setLoginData: action((state, payload) => {
        state.loginData = payload
    }),
    loginUserApi: thunk(async (actions, payload) => {

        console.log("payload==", payload.password);

        let response: any = null;
        try {
            response = await loginApi(payload);
            console.log("response?.data?.Data===", response?.data?.Data);
            localStorage.setItem("userData", JSON.stringify(response?.data?.Data))
            actions.setLoginData(response?.data?.Data);
        } catch (error) {
            response = error
        }
        return response;
    }),
    forgotPasswordApi: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await forgotPasswordApi(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getDiplomasApi: thunk(async (actions) => {
        let response: any = null;
        try {
            response = await getDiplomasApi();
        } catch (error) {
            response = error
        }
        return response;
    }),
    getStatesApi: thunk(async (actions) => {
        let response: any = null;
        try {
            response = await getStatesApi();
        } catch (error) {
            response = error
        }
        return response;
    }),
    getTimeZoneApi: thunk(async (actions) => {
        let response: any = null;
        try {
            response = await getTimeZoneApi();
        } catch (error) {
            response = error
        }
        return response;
    }),
    signUpApi: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await signUpApi(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    patientSignUpApi: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await patientSignUpApi(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    GetDashboardCounts: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await GetDashboardCounts(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    GetTherapistProfile: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await GetTherapistProfile(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),

    GetMyPatients: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await GetMyPatients(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),

    GetMyAppoinments: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await GetMyAppoinments(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),

    GetAssesmentPdf: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await GetAssesmentPdf(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    SavePatientRefuseAssessment: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await SavePatientRefuseAssessment(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    UpdateAppoinmentStatus: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await UpdateAppoinmentStatus(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    GetTherapistTimeSlots: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await GetTherapistTimeSlots(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    AdminSendEmail: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await AdminSendEmail(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    SaveNotification: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await SaveNotification(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    UploadDocument: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await UploadDocument(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    GetPatientAssessments: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await GetPatientAssessments(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    GetPatientNotes: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await GetPatientNotes(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    SavePetientNote: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await SavePetientNote(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    GetVideos: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await GetVideos(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    SaveShareVideos: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await SaveShareVideos(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    PatientSendEmail: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await PatientSendEmail(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    SaveAssessmentNotes: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await SaveAssessmentNotes(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    PatientGetProfile: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await PatientGetProfile(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientMedicalHistory: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientMedicalHistory(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getTherapistGetSchedule: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getTherapistGetSchedule(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getTherapistAppoinment: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getTherapistAppoinment(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getTherapistGetTimeInterval: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getTherapistGetTimeInterval(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getTherapistGetPopupdata: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getTherapistGetPopupdata(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    therapistSaveScheduleTime: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await therapistSaveScheduleTime(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    therapistSaveAppoinment: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await therapistSaveAppoinment(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    patientSaveAppoinment: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await patientSaveAppoinment(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    patientCancelRefuseAssessment: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await patientCancelRefuseAssessment(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    therapistRevertVPTCancelAssessment: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await therapistRevertVPTCancelAssessment(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    GetPatientPrescriptionData: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await GetPatientPrescriptionData(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    patientDischargeManage: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await patientDischargeManage(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    SaveTherapistProfile: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await SaveTherapistProfile(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    therapistSaveScheduleOnUncheck: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await therapistSaveScheduleOnUncheck(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    UploadPhoto: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await UploadPhoto(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminUploadPhoto: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminUploadPhoto(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientHealthDetails: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientHealthDetails(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    GetPatientOtherAssessment: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await GetPatientOtherAssessment(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    GetPreviousAssessment: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await GetPreviousAssessment(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    SavePatientOtherAssessment: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await SavePatientOtherAssessment(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    GetAssessmentTemplates: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await GetAssessmentTemplates(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    SaveAssessmentTemplate: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await SaveAssessmentTemplate(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientAssessment: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientAssessment(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientRefuseAssessment: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientRefuseAssessment(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientCervicalAssessment2: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientCervicalAssessment2(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientCervicalAssessment3: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientCervicalAssessment3(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientLowerAssessment3: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientLowerAssessment3(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getMedicalHistories: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getMedicalHistories(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    patientMedicalHistory: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await patientMedicalHistory(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientLumbarAssessment2: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientLumbarAssessment2(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientLumbarAssessment3: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientLumbarAssessment3(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminManageFile: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminManageFile(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminManagePatientNew: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminManagePatientNew(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminGetAppoinmentsStatus: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminGetAppoinmentsStatus(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminGetQualityAnalysisReport: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminGetQualityAnalysisReport(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminGetCAPrisonReport: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminGetCAPrisonReport(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminGetDmeSurgicalAppoinments: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminGetDmeSurgicalAppoinments(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminGetUserDetails: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminGetUserDetails(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminGetAllTherapists: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminGetAllTherapists(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminGetCompanies: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminGetCompanies(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminGetPrisonSites: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminGetPrisonSites(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminGetPrisonDiagnosisCodes: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminGetPrisonDiagnosisCodes(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),    
    adminSearchPatient: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminSearchPatient(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminSaveInboxMessage: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminSaveInboxMessage(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientLowerAssessment2: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientLowerAssessment2(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientThoracicAssessment2: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientThoracicAssessment2(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientThoracicAssessment3: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientThoracicAssessment3(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientUpperAssessment2: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientUpperAssessment2(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientUpperAssessment3: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientUpperAssessment3(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientVestibularAssessment2: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientVestibularAssessment2(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientVestibularAssessment3: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientVestibularAssessment3(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientReAssessment: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientReAssessment(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientReAssessment2: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientReAssessment2(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientGetAppoinments: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientGetAppoinments(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getSharedVideos: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getSharedVideos(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    savePatientMedicalHistory: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await savePatientMedicalHistory(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    patientAssessmentZoomDetailWeb: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await patientAssessmentZoomDetailWeb(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getPatientTherapists: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getPatientTherapists(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getCompanies: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getCompanies(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getCompaniesforPatient: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getCompaniesforPatient(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    patientSaveAppoinmentNew: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await patientSaveAppoinmentNew(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    patientRequestForAppoinment: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await patientRequestForAppoinment(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminRegisterNurse: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminRegisterNurse(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminEnableDisableUser: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminEnableDisableUser(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminOverrideUserNPI: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminOverrideUserNPI(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getAdminGetDashBoardData: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getAdminGetDashBoardData(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getAdminGetMyPatient: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getAdminGetMyPatient(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getAdminGetMyPayments: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getAdminGetMyPayments(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getAdminGetMarketingData: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getAdminGetMarketingData(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getAdminGetAppointments: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getAdminGetAppointments(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminAppRejUser: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminAppRejUser(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getAdminGetAppointmentPays: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getAdminGetAppointmentPays(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getAdminGetAccountReceived: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getAdminGetAccountReceived(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getAdminGetDischargeReport: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getAdminGetDischargeReport(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getAdminGetFirstAppoinments: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getAdminGetFirstAppoinments(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getAdminGetRequestsForAppointment: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getAdminGetRequestsForAppointment(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getAdminGetPatientDischarge: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getAdminGetPatientDischarge(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getAdminDownloadPatientDischarge: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getAdminDownloadPatientDischarge(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getAdminDownloadPatientRefusal: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getAdminDownloadPatientRefusal(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getAdminGetPatientRefusal: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getAdminGetPatientRefusal(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminUpdateAppointmentPay: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminUpdateAppointmentPay(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminGetUpdateUserFees: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminGetUpdateUserFees(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    getAdminGetAccountReceivable: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await getAdminGetAccountReceivable(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminGenerateInvoice: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminGenerateInvoice(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminGetTherapistAppoinments: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminGetTherapistAppoinments(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminGetAllTherapist: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminGetAllTherapist(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminUpdateRequestStatus: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminUpdateRequestStatus(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminUpdateAccountReceivable: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminUpdateAccountReceivable(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),    
    adminGetSelfPayAppointments: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminGetSelfPayAppointments(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    stripeCheckoutCreateIntent: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await stripeCheckoutCreateIntent(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    stripeCheckoutBookSelfPayAppointment: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await stripeCheckoutBookSelfPayAppointment(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminUpdateTherapistFees: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminUpdateTherapistFees(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    setPasswordApi: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await setPasswordApi(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    updateRstPasswordink: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await updateRstPasswordink(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
    adminSubmitClaimForm: thunk(async (actions, payload) => {
        let response: any = null;
        try {
            response = await adminSubmitClaimForm(payload);
        } catch (error) {
            response = error
        }
        return response;
    }),
}
export default appModel;